<template>
    <div>
        <PostHeader
            v-if="showPostHeader"
            :post="post"
            class="mb-3"
        />
        <div class="mb-5 flex">
            <UserAvatar
                v-if="!showPostHeader"
                is-anonymous
                size="xs"
            />
            <NsfwText
                :lang-path="text"
                class="ml-2"
            ></NsfwText>
        </div>
    </div>
</template>

<script>
import PostHeader from './PostHeader.vue';
import NsfwText from './NsfwText.vue';

export default {
    name: 'PostNsfw',
    components: {
        PostHeader,
        NsfwText,
    },
    i18nOptions: { namespaces: ['common', 'post'] },
    props: {
        post: {
            type: Object,
            required: true,
        },
        /**
         * If true, the posts header is shown with the owners avatar and profile link (e.g. when just created/edited a post with an nsfw image)
         * If false, there is no post header an anonymous avatar is shown to the left of the text
         * */
        showPostHeader: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        text() {
            return this.post.isOwner ? 'post:nsfw.postOwner' : 'post:nsfw.post';
        },
    },
};
</script>
